import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    profileUrl: localStorage.getItem("profileUrl") || "",
    clientMappingArray:[],
    branchMappingArray:[],
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        setProfileUrl: (state, action: PayloadAction<string>) => {
            state.profileUrl = action.payload;
            localStorage.setItem("profileUrl", action.payload);
        },
        clearProfileUrl: (state) => {
            state.profileUrl = "";
            localStorage.removeItem("profileUrl");
        },
        setUpdateUserDetails:(state, action)=>{
            return { ...state, ...action.payload };
        },
    },
});

export const { setProfileUrl, clearProfileUrl,setUpdateUserDetails } = profileSlice.actions;
export default profileSlice.reducer;
